import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import StatusLayout from "./StatusLayout";
import { downloadGenericResult, fetchCaseStatus } from "../../lib/everifyStatusApi";
import { useCase } from "../../context/CaseContext";
import { toast } from "react-toastify";

const QueuedPage = () => {
  const navigate = useNavigate();
  const { activeCaseNumber } = useCase();
  const [downloadLoading, setDownloadLoading] = useState(false);

  const { data: statusData } = useQuery({
    queryKey: ["case-status", activeCaseNumber],
    queryFn: () => fetchCaseStatus(activeCaseNumber),
    enabled: Boolean(activeCaseNumber),
    staleTime: 1000 * 60,
  });

  const handleDownload = async () => {
    try {
      setDownloadLoading(true);
      await downloadGenericResult(activeCaseNumber, `queued-${activeCaseNumber}.pdf`);
    } catch (error) {
      toast.error("Unable to download result.");
    } finally {
      setDownloadLoading(false);
    }
  };

  const nextStepsText = statusData?.message?.split("\n") ?? [
    "No Actions Required",
    "You can find the updated status in the E-Verify Home Page.",
  ];

  const footerActions = [
  ];

  return (
    <StatusLayout
      title="Queued"
      description={statusData?.reason || "The case is being processed by government systems. Please wait !"}
      footerActions={footerActions}
    >
      <div className="status-section">
        <h3>Next Steps</h3>
        {nextStepsText.map((line, index) => (
          <p key={index}>{line}</p>
        ))}
      </div>
    </StatusLayout>
  );
};

export default QueuedPage;
